import { BaseDto } from './base.dto';
export class BaseStatusDto extends BaseDto {
  name: string;
  key: string;
}
